/**
 * How many configured gaps are still blank.
 *
 * A gap counts as answered once it holds a non-whitespace value, wherever its
 * field was rendered (inline at a __N__ placeholder, or in the separate list).
 */
export function countUnansweredGaps(gaps = [], gapAnswers = []) {
  return gaps.filter(
    (_, index) => String(gapAnswers[index] ?? "").trim().length === 0,
  ).length;
}

/**
 * Returns true when every configured gap has a non-blank answer.
 *
 * An exercise with no configured gaps is complete: an invalid authoring
 * definition must not make the candidate look unfinished.
 *
 * Blanks do not block submission — the candidate confirms and submits an
 * incomplete form, and timer expiry submits regardless. This drives the
 * warning and the confirmation dialog, not the Continue button.
 */
export function areGapAnswersComplete(gaps = [], gapAnswers = []) {
  return countUnansweredGaps(gaps, gapAnswers) === 0;
}
